// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../../types';

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ProposalButtonsProposalFragment = { __typename?: 'Proposal', ID: number };

export type ProposalButtonsMutationMutationVariables = Types.Exact<{
  input: Types.ReqToBookIn;
}>;


export type ProposalButtonsMutationMutation = { __typename?: 'Mutation', requestToBook: { __typename?: 'Proposal', eventID: number, status: Types.ProposalStatus, hostID: number, spaceID: number, baseCostDescription: string, baseCostTotal: number, currency: string, message?: string | null, fromDateTime: string, toDateTime: string, attendees: number, extraCostItems?: Array<{ __typename?: 'ExtraCostItem', description: string, costPerUnit: number }> | null, documents?: Array<{ __typename?: 'ProposalDocument', ID: number, filename: string }> | null } };

export const ProposalButtonsProposalFragmentDoc = gql`
    fragment ProposalButtonsProposal on Proposal {
  ID
}
    `;
export const ProposalButtonsMutationDocument = gql`
    mutation ProposalButtonsMutation($input: ReqToBookIn!) {
  requestToBook(input: $input) {
    eventID
    status
    hostID
    spaceID
    baseCostDescription
    baseCostTotal
    extraCostItems {
      description
      costPerUnit
    }
    documents {
      ID
      filename
    }
    currency
    message
    fromDateTime
    toDateTime
    attendees
  }
}
    `;

export function useProposalButtonsMutationMutation() {
  return Urql.useMutation<ProposalButtonsMutationMutation, ProposalButtonsMutationMutationVariables>(ProposalButtonsMutationDocument);
};